import type { RevocationList } from '@slate/plugin-api';

/**
 * v1 bundled, static revocation list. Empty by default. The marketplace kill
 * switch (spec §8) populates this before Part 6 ships a remote-fetched + cached
 * source. To revoke a plugin now, add an entry, e.g.:
 *   { id: 'evil.plugin', reason: 'malware' }                 // all versions
 *   { id: 'acme.demo', versions: ['1.2.0'], reason: 'CVE' }  // only 1.2.0
 */
export const BUNDLED_REVOCATION_LIST: RevocationList = { revoked: [] };

/** Future (Part 6): fetch the list from the marketplace and cache it locally.
 *  Not implemented in this slice; the kill switch already accepts any list. */
export interface RevocationSource {
  load(): Promise<RevocationList>;
}
